import { Controller } from '@hotwired/stimulus'
import bash from '../highlight_bash.js'
import hljs from 'highlight.js/lib/core'
import http from 'highlight.js/lib/languages/http'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import python from 'highlight.js/lib/languages/python'
import ruby from 'highlight.js/lib/languages/ruby'
import xml from 'highlight.js/lib/languages/xml'

export default class extends Controller {
  connect() {
    hljs.registerLanguage('bash', bash)
    hljs.registerAliases('cli', { languageName: 'bash' })
    hljs.registerLanguage('http', http)
    hljs.registerLanguage('javascript', javascript)
    hljs.registerLanguage('json', json)
    hljs.registerLanguage('python', python)
    hljs.registerLanguage('ruby', ruby)
    hljs.registerLanguage('xml', xml)

    hljs.highlightAll()
  }
}
